import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {BasePrintService} from "@shared-services/print/base-print.service";
import {ConsoleContextService} from "projects/soko-console-web-v2/src/app/security/console-context.service";
import {environment} from "projects/soko-console-web-v2/src/environments/environment";
import {Observable} from "rxjs";
import {CustomPrintStyles, PrintDocumentInfo} from "src/app/shared/interfaces/print.interface";

@Injectable({
  providedIn: 'root'
})
export class PrintApplicationService extends BasePrintService {

  constructor(http: HttpClient, context: ConsoleContextService) {
    super(context, http)
  }

  public async getApplicationPrint(retailerId: string, docInfo: PrintDocumentInfo, offeringId: string, customStyles?: CustomPrintStyles): Promise<Observable<Blob>> {
    const headers = {
      'x-retailer-id': retailerId
    }
    return this.getPrintPdf(docInfo, offeringId, '/print/application', headers, customStyles);
  }

  public raiseDownloadApplicationEvent(retailerId: string, docId: string) {
    const url = environment.apiRetailersHost + `/console/offering/district/pipeline/applications/${retailerId}/assessment/download`;
    return this.http.post<void>(url, docId)
  }

}
